<template>
  <v-container class="cmp-contacts-groups-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <ContactGroupDetails
        :group="selectedContactGroup && selectedContactGroup.group"
        :selected-contact-group="selectedContactGroup"
      ></ContactGroupDetails>

      <glayout
        :tabs="contactSidewindowTabs"
        :menu="[
          { text: 'Group Email', value: 'group_email' },
          {
            text: $t('export_csv'),
            value: 'export_csv',
          },
          {
            text: $t('delete_group'),
            value: 'delete_group',
            error: true,
          },
        ]"
        :loading="selectedContactGroup && selectedContactGroup.loading"
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('group_info')" h="180">
                <GroupInfo
                  v-if="selectedContactGroup && selectedContactGroup.group"
                  :group="selectedContactGroup.group"
                  :selected-contact-group="selectedContactGroup"
                  @changed="onGroupChanged"
                />
              </gbox>
            </gcol>
            <gcol></gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedContactGroup &&
                      selectedContactGroup.contacts &&
                      selectedContactGroup.contacts.length
                  )
                "
                :title="$t('related_contacts')"
              >
                <GroupContacts
                 
                  :selected-contact-group="selectedContactGroup"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <v-dialog v-model="groupEmailsModal" persistent width="562">
      <EmailsModal
        :emails="groupEmails"
        @cancelled="onGroupEmailsModalCancelled"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { ContactStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../../store/types";

// import VueGridLayout from "vue-grid-layout";
// import BoxWidget from "@plugins/box-widget/box-widget";

import { createGridHost } from "@/dt-plugins/sidewindow/grid-host.mixin";
import { contactDetailsGrid, contactGridRouteMap } from "./sw-grid";
import {
  checkTabListPermission,
  checkTabGridItemPermission,
} from "../../../../router/guard";

import ContactGroupDetails from "./contact-group-details";
import GroupContacts from "./group-contacts";
import { contactGroupsListLDTRoutes } from "../../router/routes";
import GroupInfo from "./group-info";
import { HttpClient } from "../../../../services/http/http-client";
import { ContactGroupsService } from "../../services/contact_groups.service";
import EmailsModal from "./emails-modal";
import FileDownload from "js-file-download";
const moduleRoute = "contacts";
const submenuRoute = "groups";

export default {
  components: {
    // GridLayout: VueGridLayout.GridLayout,
    // GridItem: VueGridLayout.GridItem,
    // BoxWidget,
    GroupContacts,
    ContactGroupDetails,
    GroupInfo,
    EmailsModal,
  },
  data: function () {
    return {
      active: -1,
      groupEmailsModal: false,
      groupEmails: [],
      // gridLayout: checkTabGridItemPermission(
      //   moduleRoute,
      //   submenuRoute,
      //   contactDetailsGrid,
      //   contactGridRouteMap
      // )
    };
  },
  mixins: [
    // createGridHost({
    //   layoutName: "gridLayout"
    // })
    createDTGridHost(),
  ],
  mounted: function () {},
  watch: {},
  computed: {
    ...mapGetters(storeNS, {
      // selectedContactGroup: "selectedContactGroup",
      // selectedContactGroupLoading: "selectedContactGroupLoading",
      contactGroupDetails: "contactGroupDetails"
      // contactDetailsGrid: "contactDetailsGrid"
    }),
    group_id: function() {
      return this.$route.params.group_id;
    },
    selectedContactGroup: function() {
      const groupDefault = {group: {}};
      const selectedGroupDetails =  (this.contactGroupDetails || [])[this.group_id] || groupDefault;
      return {...selectedGroupDetails};
    },
    activeTabIndex: {
      get: function () {
        return `${0}`;
      },
      set: function (value) {},
    },
    contactSidewindowTabs: function () {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview", // Route Value
          value: this.$t("tab_title_overview"), // Tab Name
        },
        // {
        //   route: "overview",
        //   value: "Overview",
        //   vgi_id: "location_info"
        // }
      ]);
    },
    selectedContactId: function () {
      return this.selectedContact.contact.contact_id;
    },
    contact_relation_table: function () {
      return this.selectedContact.contact.getExternalTable();
    },
    // sidewindowOptions: function() {
    //   return [
    //     { text: "Group Email", value: "group_email" },
    //     {
    //       text: "EXPORT CSV",
    //       value: "export_csv"
    //     },
    //     {
    //       text: "Delete Group",
    //       value: "delete_group",
    //       error: true
    //     }
    //   ];
    // }
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.SelectedContactGroups.DELETE.SINGLE]:
        ActionTypes.SelectedContactGroups.DELETE.SINGLE,
      [ActionTypes.SelectedContact.UPDATE.SINGLE]:
        ActionTypes.SelectedContact.UPDATE.SINGLE,
      [ActionTypes.SelectedContactRelatedContacts.UPDATE.SINGLE]:
        ActionTypes.SelectedContactRelatedContacts.UPDATE.SINGLE,
      [ActionTypes.SelectedContactRelatedContacts.DELETE.SINGLE]:
        ActionTypes.SelectedContactRelatedContacts.DELETE.SINGLE,
      [ActionTypes.ContactGroupDetails.UPDATE.SINGLE]:
      ActionTypes.ContactGroupDetails.UPDATE.SINGLE,
     
    }),
    
    onGroupEmailsModalCancelled() {
      this.groupEmailsModal = false;
    },
    onContactGroupDelete: function () {
      //1:
      this.$emit("deleteGroup", this.selectedContactGroup.group);
    },
    onTabOptionClicked: function (value) {
      switch (value) {
        case "export_csv":
          this.onCSVButtonClicked();
          break;
        case "group_email":
          this.onGroupEmailsModalOpen();
          break;
        case "delete_group":
          this.onContactGroupDelete();
          break;
        default:
          break;
      }
    },
    closeContactGroupDetails: function () {
      this.$emit("closeGroupSidewindow", true);
    },
    onGroupEmailsModalOpen() {
      this.groupEmailsModal = true;
      ContactGroupsService.getContactGroupEmails(
        this.selectedContactGroup.group.group_id
      ).then((res) => {
        let formatedArr = [];
        res.data.contact_emails.forEach((el) => {
          if (el.email1) {
            formatedArr.push(el.email1);
          }
          if (el.email2) {
            formatedArr.push(el.email2);
          }
        });
        this.groupEmails = formatedArr.join("\n");
      });
    },
    onCSVButtonClicked() {
      ContactGroupsService.getContactGroupCSV(
        this.selectedContactGroup.group.group_id
      ).then((res) => {
        FileDownload(
          res.data,
          this.selectedContactGroup.group.group_name + "_contacts.csv"
        );
      });
    },
    tabSelected: function (e) {
      this.$router.push({
        name: contactGroupsListLDTRoutes.names.tab,
        params: {
          tab: this.contactSidewindowTabs[e].route,
        },
      });
    },
    onSelectedContactNoteBlur: function (event) {
      // console.log(event);
      const { value } = event.target;
      this[ActionTypes.SelectedContact.UPDATE.SINGLE]({
        name: "notes",
        value,
      });
    },
    onGroupChanged: function (payload) {
      this[ActionTypes.ContactGroupDetails.UPDATE.SINGLE](payload);
    },
    onGroupDelete: function (group) {
      this[ActionTypes.SelectedContactGroups.DELETE.SINGLE](group);
    },
    onContactChange: function ({ name, value }) {
      this[ActionTypes.SelectedContact.UPDATE.SINGLE]({
        name,
        value,
      });
    },
    onRelatedContactDelete: function (contact) {
      this[ActionTypes.SelectedContactRelatedContacts.DELETE.SINGLE](contact);
    },
    onRelatedContactChange: function ({ name, value, item }) {
      this[ActionTypes.SelectedContactRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-contacts-groups-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 119px);
  }

  .navigation-drawer--right .grids-page {
    height: calc(100vh - 170px);
  }

  .dt-details {
    margin-top: 5px;
  }

  .rss-feed {
    font-weight: 600;
    text-decoration: none;
  }

  .app-section {
    .dt-list .dt-list-item--options {
      min-width: 20px;
    }
    .app-section-bottom {
      position: absolute;
      width: 100%;
      bottom: 10px;
    }
  }
}
</style>
